module.exports = __webpack_public_path__ + "media/ห้ามแตะตัวพระผู้เป็นเจ้านะคะ.624ded10.mp3";